<template>
  <div class="share">

    <div class="share__label" v-on:click="toggleShare">SHARE</div>

    <div v-if="open" class="share__icons">
      <a 
        :class="'share__icon share__icon--facebook'"
        :href="'https://www.facebook.com/sharer/sharer.php?u=' + baseUrl" 
        target="_blank"
      />
      <a 
        :class="'share__icon share__icon--twitter'"
        :href="'https://twitter.com/intent/tweet?text=' + 'Celebrate 75 years of Elton John by adding your own Brick to the Yellow Brick Road&url=' + baseUrl" 
        target="_blank"
      />
      <a 
        :class="'share__icon share__icon--copy'"
        @click.prevent="copyurl();"
        target="_blank"
        v-if="supportsCB"
      >
        <transition name="appear">
          <div class="share__copied-label" v-if="copied == true">COPIED</div>
        </transition>
      </a>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'Share',

    computed: {
      baseUrl() {
        return process.env.VUE_APP_BASE_URL
      },
    },
    
    data() {
      return {
        copied: false,
        open: false,
        supportsCB:true,
      }
    },
    
    mounted () {
      if (navigator.clipboard) this.supportsCB = true;
    },

    methods: {
      toggleShare() {
        this.open = !this.open;
      },
      copyurl() {
        navigator.clipboard.writeText( this.baseUrl );
        this.copied = true;
        setTimeout( () => {this.copied = false}, 2300 )
      },
    },
  }
</script>
